import { render } from "./DashboardStatusFiltersOld.vue?vue&type=template&id=174c0224"
import script from "./DashboardStatusFiltersOld.vue?vue&type=script&lang=js"
export * from "./DashboardStatusFiltersOld.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__